
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '包装种类名称',
value: this.$route.params.PT_NAME
}, {
label: '包装种类说明',
value: this.$route.params.PT_Remark
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/P_PackingTypeDetail.vue